<script setup lang="ts">
import { IGenericUser } from '@/interfaces';
import DisplayName from './DisplayName.vue';
import UserAvatar from './UserAvatar.vue';
import UserStatus from './UserStatus.vue';
import { useMobile } from '@/composables/useMobile';

defineProps<{
  user: IGenericUser;
  titleClass?: string;
}>();

const { isMobile } = useMobile();
</script>

<template>
  <div class="flex min-w-0 items-center gap-sm">
    <UserAvatar class="mr-md !size-button" :user="user" />
    <div class="flex min-w-0 flex-col flex-grow text-left">
      <div class="flex items-center w-full">
        <div class="text-truncate font-semibold" :class="titleClass">
          <DisplayName :person="user" email-fallback />
        </div>
        <UserStatus
          v-if="user.deactivatedAt"
          :user="user"
          size="xs"
          class="ml-sm"
          :hide-label-when-tooltip="isMobile"
        />
        <slot name="name-suffix" />
      </div>
      <slot />
    </div>
  </div>
</template>
